import { Intent } from "@blueprintjs/core";
import { ButtonWithDialog } from "@focus/focusUI";
import { useMemo } from "react";
import { ROLES, useRoles } from "../../hooks/useRoles";
import { useUserController } from "../../hooks/useUserController";
import type { User } from "../../types/users";

interface DeleteUserButtonProps {
  user?: User;
  disabled?: boolean;
}

export const DeleteUserButton = ({ user, disabled }: DeleteUserButtonProps) => {
  const { organizations, deleteUser } = useUserController();
  const { roles } = useRoles();
  const canDelete = useMemo(() => {
    if (roles.includes(ROLES.ADMIN)) return true;
    if (!roles.includes(ROLES.ORG_ADMIN)) return false;

    return (
      user?.organizations?.some((org) => organizations.includes(org)) ?? false
    );
  }, [roles, organizations, user?.organizations]);

  if (!canDelete) return null; // Do not show button

  return (
    <ButtonWithDialog<null>
      icon="trash"
      minimal
      intent={Intent.DANGER}
      headerTitle="Confirm Delete"
      defaultContent={null}
      closeAfterAccept={true}
      onAccept={() => {
        deleteUser(user?.id);
      }}
      hideButtons={false}
      form={() => (
        <div className="w-full p-4 text-center space-y-3">
          <p>
            Are you sure you want to delete <b>{user?.username}</b>?
          </p>
          <p className="text-sm text-gray-500">This action cannot be undone.</p>
        </div>
      )}
      tooltipText="Delete user account"
      disabled={disabled}
    />
  );
};
